import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ArrowsAltOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowsAltOutlined";
import AntdIcon from "../components/AntdIcon";
var ArrowsAltOutlined = function ArrowsAltOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ArrowsAltOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ArrowsAltOutlined.displayName = 'ArrowsAltOutlined';
}
export default /*#__PURE__*/React.forwardRef(ArrowsAltOutlined);